module.exports = __webpack_public_path__ + "static/media/room-1.53243da3.jpg";